export default "__VITE_PUBLIC_ASSET__fc76d784__"